import BenefitsSection from "./benefitsSection"
import ScrollingFeatures from "./scrollingBenefits"
import HVACReviews from "./below"
import InfiniteScroll from "./scrollingLogos"
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { motion } from 'framer-motion'
import OurBenefits from "./ourBenefits"


export default function HomePage() {
    return (
        <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="bg-white text-black font-sans"
        >
              {/* Hero Section */}
        <section className="relative md:h-[800px] h-[600px] flex flex-col justify-center items-start md:mt-0 mt-10 px-10">
            <motion.video
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1.2 }}
                className="absolute inset-0 w-full h-full object-cover"
                autoPlay
                loop
                muted
            >
                <source src="/installVideo.mp4" type="video/mp4" />
            </motion.video>
            <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="absolute inset-0 bg-gradient-to-r from-white via-white/50 to-transparent"
            ></motion.div>
            <motion.div 
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="relative z-1"
            >
                <motion.h1 
                    initial={{ y: -20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.5 }}
                    className="text-5xl font-bold text-black"
                >
                    iFLO PRO
                </motion.h1>
                <motion.p 
                    initial={{ y: -20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.7 }}
                    className="mt-2 text-3xl max-w-lg text-black"
                >
                    The best way to improve customer experience & satisfaction guaranteed.
                </motion.p>
                {/*<motion.div 
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.9 }}
                    className="mt-4 flex flex-wrap gap-6 mb-6"
                >
                    <motion.div 
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="flex items-center gap-2 border border-gray-200 bg-white/80 rounded-lg px-3 py-2 shadow-sm"
                    >
                        <CheckCircleIcon className="h-5 w-5 text-yellow-400" />
                        <span className="text-sm font-medium">Reduce Callbacks</span>
                    </motion.div>
                    <motion.div 
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="flex items-center gap-2 border border-gray-200 bg-white/80 rounded-lg px-3 py-2 shadow-sm"
                    >
                        <CheckCircleIcon className="h-5 w-5 text-yellow-400" />
                        <span className="text-sm font-medium">Enhance Customer Experience</span>
                    </motion.div>
                    <motion.div 
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="flex items-center gap-2 border border-gray-200 bg-white/80 rounded-lg px-3 py-2 shadow-sm"
                    >
                        <CheckCircleIcon className="h-5 w-5 text-yellow-400" />
                        <span className="text-sm font-medium">Improve Customer Retention</span>
                    </motion.div>
                </motion.div>*/}
                <motion.div 
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6, delay: 1.1 }}
                    className="mt-6 flex space-x-4"
                >
                    <motion.a 
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        href="/contact-us"
                    >
                        <button className="bg-yellow-400 text-black px-6 py-3 font-bold rounded-lg transition-all hover:bg-yellow-500">
                            Schedule a Call
                        </button>
                    </motion.a>
                    <motion.a 
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        href="#benefits"
                    >
                        <button className="border border-yellow-400 text-black px-6 py-3 font-bold rounded-lg transition-all hover:bg-yellow-50">
                            Learn More
                        </button>
                    </motion.a>
                </motion.div>
            </motion.div>
        </section>

        {/* Trusted Distributors Section */}
        <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center py-10 text-xl border-t-2 border-yellow-400 font-semibold text-black"
        >
            Our Trusted Distributors
        </motion.div>

        {/* Infinite Scroll Section */}
        <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
        >
            <InfiniteScroll />
        </motion.div>

        {/* Benefits Section */}
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
        >
            <BenefitsSection />
        </motion.div>

        {/* Scrolling Benefits Section */}
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
        >
            <OurBenefits />
        </motion.div>

        {/* HVAC Reviews Section */}
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
        >
            <HVACReviews />
        </motion.div>

        </motion.div>
    )
}